import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { media } from '../../helpers/responsive';
import type { RootState } from '../../state/store';
import { createCompanyDateSelectionPresets } from '../../helpers/utils';

interface DatePresetSectionProps {
  applyFilters: (presetDates: any, presetTime: any) => void;
}

const DatePresetSection = ({ applyFilters }: DatePresetSectionProps) => {
  const { dates: selectedDate } = useSelector((state: RootState) => state.filters);
  const { company } = useSelector((state: RootState) => state);

  const getClassName = useCallback(
    (presetDates: any) => {
      return `preset ${
        presetDates[0] === selectedDate[0] && presetDates[1] === selectedDate[1] ? 'selected' : ''
      }`;
    },
    [selectedDate]
  );

  const selectPresetDate = (presetDates: any, presetTime: any) => {
    applyFilters(presetDates, presetTime);
  };

  const dateRangePresets = createCompanyDateSelectionPresets({
    businessEndTimeInSecs: company?.company_details?.business_end_time || 0,
    timezoneOffset: company?.company_details?.time_zone_offset
  });

  return (
    <Wrapper>
      <span className="heading">Quick Selection: </span>
      {Object.entries(dateRangePresets)
        .map((a) => a[1])
        .map((d, i) => (
          <span
            key={i}
            className={getClassName(d.date_range)}
            onClick={() => selectPresetDate(d.date_range, d.time_range)}
          >
            {d.title}
          </span>
        ))}
    </Wrapper>
  );
};

export default DatePresetSection;

const Wrapper = styled.div`
  .heading {
    font-size: 16px;
    font-weight: bold;
  }
  .preset {
    font-size: 16px;
    font-weight: 400;
    margin: 0 10px;
    cursor: pointer;
    user-select: none;
    &:hover {
      text-decoration: underline;
    }
    &.selected {
      font-weight: 700;
      color: #14785f;
      pointer-events: none;
      &:hover {
        text-decoration: none;
      }
    }
  }
  padding-bottom: 11px;
  border-bottom: 1px solid ${({ theme }) => theme.border_color};

  ${media.down.xs} {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 0;
    .heading {
      font-size: 13px;
      flex: 0 0 100%;
      margin-bottom: 4px;
    }
    .preset {
      font-size: 13px;
      margin: 0 6px 0 0;
    }
  }
`;
